import { apiPut, buildApiURL } from '@src/services/api';

const postCheckout = (data) => {
    return apiPut(
        buildApiURL('/api/v1/cart_items/checkout'),
        { ids: data },
    );
};

export {
    postCheckout,
};
